"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AnsweredQuestionnaire_1 = require("../Model/Question/AnsweredQuestionnaire");
const Collection_1 = require("../Model/Collection");
class AnsweredQuestionnaireToDataTransformer {
    constructor(questionTransformer) {
        this.questionTransformer = questionTransformer;
    }
    /**
     * @inheritDoc
     */
    to(questionnaire) {
        return {
            token: questionnaire.getToken(),
            questionnaireId: questionnaire.getId(),
            answeredQuestions: questionnaire.getAnsweredQuestions().map((answer) => this.questionTransformer.to(answer))
        };
    }
    /**
     * @inheritDoc
     */
    from(data) {
        const answeredQuestions = new Collection_1.default((data.answeredQuestions.items || []).map((answer) => this.questionTransformer.from(answer)));
        return new AnsweredQuestionnaire_1.default()
            .setId(data.questionnaire)
            .setToken(data.token)
            .setAnsweredQuestions(answeredQuestions);
    }
}
exports.default = AnsweredQuestionnaireToDataTransformer;
